import { render, staticRenderFns } from "./UnauthorizedFeature.vue?vue&type=template&id=710e93d5&"
import script from "./UnauthorizedFeature.vue?vue&type=script&lang=js&"
export * from "./UnauthorizedFeature.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports